/** Opening a keyword's detail from a list.
 *
 *  The detail has an address, `/apps/:id/keywords/:kid`, so a reload or a
 *  shared link lands on it. Opened from a page it carries that page as its
 *  `background`: from 1024px up the page stays drawn (filters, scroll) with the
 *  detail as a drawer over it; below, the detail is a page of its own. */

import type { Location } from 'react-router-dom'
import { useLocation, useNavigate } from 'react-router-dom'

export interface DetailState {
  /** The page the detail was opened from; it stays drawn under the drawer. */
  background?: Location
}

export function keywordPath(appId: number, keywordId: number): string {
  return `/apps/${appId}/keywords/${keywordId}`
}

/** `open(appId, keywordId)` shows that keyword over the current page. */
export function useOpenKeyword() {
  const navigate = useNavigate()
  const location = useLocation()
  return (appId: number, keywordId: number) => {
    const bg = (location.state as DetailState | null)?.background ?? location
    navigate(keywordPath(appId, keywordId), { state: { background: bg } satisfies DetailState })
  }
}
